import classNames from 'classnames';
import React from 'react';
import LazyLoad from 'react-lazy-load';
import { Select, Theme } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { FontItem } from '../';
import FontItemCom from './fontItem';

const { AppTheme } = Theme;

interface IFontGroupItemProps<T extends FontItem> {
    fontGroupName: string;
    fontItems: T[];
    fontName: string | null;
    lazyLoadRenderKey: number;
    openGroups: string[];
    theme: any;
    onFontFamilyChange: (item: T) => void;
    onMouseEnter: (item: T) => void;
    onFontGroupNameChange: (fontGroupName: string) => void;
    onTrackShow?: (item: T) => void;
}

const { Option } = Select;

const FontGroupItem = <T extends FontItem>(props: IFontGroupItemProps<T>) => {
    const {
        fontGroupName,
        fontItems,
        fontName,
        lazyLoadRenderKey,
        openGroups,
        theme,
        onFontFamilyChange,
        onMouseEnter,
        onFontGroupNameChange,
        onTrackShow,
    } = props;

    //  获取字体背景图
    const getFontImage = (item: T) => {
        const thumbnail = theme === AppTheme.dark ? item?.font_group_thumbnail_white : item?.font_group_thumbnail_dark;

        return thumbnail;
    };

    const defaultFontItem = fontItems.find((item) => item.font_weight_value === 400) ?? fontItems[0];

    const isOpenGroup = openGroups.includes(fontGroupName);

    const isSelectGroupChild = fontItems.find((item) => item.font_name === fontName);

    const isActive = isSelectGroupChild && !isOpenGroup;

    const fontGroupThumbnail = getFontImage(isSelectGroupChild ?? defaultFontItem);
    return (
        <React.Fragment key={fontGroupName}>
            <Option
                key={fontGroupName}
                className={classNames('text-fontFamily__group', {
                    active: isActive,
                })}
            >
                <div
                    className="text-fontFamily__group-content"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        // 如果当前组有选中字体, 或者组是打开的, 则不进行点击
                        if (isSelectGroupChild || isOpenGroup) return;

                        onFontFamilyChange(defaultFontItem);
                    }}
                >
                    <div
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onFontGroupNameChange(fontGroupName);
                        }}
                    >
                        <IconFont name={isOpenGroup ? 'ChevronDownBlack' : 'ChevronRightBlack'} />
                    </div>

                    {/* 需要用lazyLoadRenderKey控制lazyLoad初始化时机, 不然展示有问题 */}
                    {fontGroupThumbnail ? (
                        <LazyLoad key={lazyLoadRenderKey}>
                            <img src={fontGroupThumbnail} className="text-fontFamily__group-image" />
                        </LazyLoad>
                    ) : (
                        <div className="text-fontFamily__group-text">{fontGroupName}</div>
                    )}
                </div>
            </Option>
            {fontItems.map((item, index) =>
                FontItemCom({
                    item,
                    index,
                    isGroupChildren: true,
                    lazyLoadRenderKey,
                    theme,
                    onClick: onFontFamilyChange,
                    onMouseEnter,
                    onTrackShow,
                    style: {
                        height: isOpenGroup ? 'auto' : '0',
                    },
                }),
            )}
        </React.Fragment>
    );
};

export default FontGroupItem;
